import { render, staticRenderFns } from "./Pathology.vue?vue&type=template&id=5abe3809&"
import script from "./Pathology.vue?vue&type=script&lang=js&"
export * from "./Pathology.vue?vue&type=script&lang=js&"
import style0 from "./Pathology.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports